import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Ref,
  Setup,
  toNative,
  Vanilla,
  Vue as VueFromDecorator,
  Watch,
} from 'vue-facing-decorator'

// Import types needed for the augmentation
import type Flickity from 'flickity'
import type {
  RouteLocationNormalizedLoaded,
  RouteLocationRaw,
  Router,
} from 'vue-router'
import type { ScrollTo } from '~/plugins/scrollto'
import type { I18n } from '../lang/plugins/vue-i18n'

export {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Ref,
  Setup,
  toNative,
  Vanilla,
  Watch,
}

// Define an interface for the properties we expect on Vue instances
interface PuVueInstance {
  $isDesktop: boolean
  $route: RouteLocationNormalizedLoaded
  $router: Router
  $t: (key: string, ...args: any[]) => string
  $puLocalePath: (route: RouteLocationRaw, locale?: string) => string
  $puScrollTo: ScrollTo
  $routerClient: {
    routeChanged(to: RouteLocationNormalizedLoaded): void
    getReferrer(): RouteLocationNormalizedLoaded | undefined
    getHistory(): RouteLocationNormalizedLoaded[]
  }
  $getFlickity: () => Promise<Flickity>
  $i18n: I18n

  // Core Vue instance methods/properties
  $emit: (event: string, ...args: any[]) => void
  $attrs: Record<string, any>
  $slots: Record<string, any>

  // BaseInput mixin properties (for components that extend it)
  validationRules?: any
  modelValue?: string
  name?: string
  disabled?: boolean
  validationErrors?: string[]
  hasError?: (errors?: string[]) => boolean
  isRequired?: boolean
}

// Assert that VueFromDecorator (the class from vue-facing-decorator)
// conforms to our PuVueInstance interface for typing purposes.
// This doesn't change runtime behavior but helps TypeScript.
export const Vue = VueFromDecorator as typeof VueFromDecorator & {
  new (...args: any[]): PuVueInstance
}
